import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import MoreIcon from '@/assets/svg/bx-dots-vertical-rounded.svg?react';
import FilterIcon from '@/assets/svg/bx-filter.svg?react';
import MetricSelectorIcon from '@/assets/svg/bx-layout.svg?react';
import { Button } from '@/components/buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';
import { csvDownloadRowLimit } from '@/constants/numbers';
import { ExportCSVAction } from '@/features/ExportCSVAction';

type Props = {
  totalResults?: number;
  isLoading?: boolean;
  isDownloadingCSV?: boolean;
  onDownloadCSV?: () => void;
  onOpenMetricSelector?: () => void;
  onOpenAdvancedFilters?: () => void;
};

const ActivityActionMenu = ({
  totalResults,
  isLoading,
  isDownloadingCSV,
  onDownloadCSV,
  onOpenMetricSelector,
  onOpenAdvancedFilters,
}: Props) => {
  const downloadRowLimitReached = totalResults != null && totalResults > csvDownloadRowLimit;
  const exportDisabled = downloadRowLimitReached || isLoading || isDownloadingCSV;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="ghost" size="icon" aria-label={t`More actions`}>
            <MoreIcon />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onOpenAdvancedFilters}>
          <FilterIcon />
          <Trans>Advanced Filters</Trans>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onOpenMetricSelector}>
          <MetricSelectorIcon />
          <Trans>Metrics Selection</Trans>
        </DropdownMenuItem>
        <DropdownMenuItem disabled={exportDisabled} onClick={onDownloadCSV}>
          <ExportCSVAction downloadRowLimitReached={downloadRowLimitReached} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActivityActionMenu;
